import {
  GET_USER_INFO_SUCCESS,
  USER_LOGIN_OUT_SUCCESS,
} from '../actions/account';
import { AccountState } from '../types/account';
import { AccountActions } from '../actions/account';
import _ from 'lodash';

const initState: Partial<AccountState> = {
  admin: false,
  menus: [],
  suppliersList: [],
};

export default function (
  state: Partial<AccountState> = initState,
  action: AccountActions,
): Partial<AccountState> {
  switch (action.type) {
    case GET_USER_INFO_SUCCESS: {
      const data = action.data;
      return { ...state, ...data };
    }
    case USER_LOGIN_OUT_SUCCESS: {
      return { ...initState };
    }
    default: {
      return state;
    }
  }
}
